import { BANNER_TYPES } from '@sravni/react-advertisement/lib/constants';
import type { BannerType } from '@sravni/react-advertisement/lib/types';

export const DEFAULT_BORDERED_BANNERS: BannerType[] = [BANNER_TYPES.TGBM_7, BANNER_TYPES.SIDE];

export const BANNER_TYPES_LIST: BannerType[] = [
  BANNER_TYPES.TGBM_7,
  BANNER_TYPES.OUT_OF_PAGE,
  BANNER_TYPES.SIDE,
  BANNER_TYPES.TOP,
];

export const RELOADED_BANNERS: BannerType[] = [BANNER_TYPES.TGBM_7, BANNER_TYPES.SIDE];
